let isEmbedded = false;

export function isEmbeddedApp() {
  if (isEmbedded || location.search.includes('embedded=true')) {
    isEmbedded = true;
  }
  return isEmbedded;
}
